import { RegisterOptions } from "react-hook-form";
import { useAddressFormOperations } from "../../../helpers/addressesHelpers";
import AutocompleteSelectInput from "../AutocompleteSelectInput";
import AddressSearchProviderFooter from "./AddressSearchProviderFooter";
import { useCustomTranslation } from "../../../helpers/translateHelpers";

interface AddressAutocompleteInputProps {
  name: string;
  placeholder?: string;
  required?: boolean;
  className?: string;
  options?: RegisterOptions;
  prefix?: string;
  setShowAllFields?: () => void;
  disableCreate?: boolean;
}

const AddressAutocompleteInput = ({
  name,
  className,
  options,
  placeholder,
  required,
  prefix,
  setShowAllFields,
  disableCreate,
}: AddressAutocompleteInputProps) => {
  const { loadAddresses, handleSelect, cleanInputsValues } =
    useAddressFormOperations();
  const { tInput } = useCustomTranslation();

  const handleSwitchToAllFields = () => {
    setShowAllFields?.();
    cleanInputsValues();
  };

  return (
    <AutocompleteSelectInput
      name={name}
      loadOptions={(inputValue, cb) => loadAddresses(inputValue, cb)}
      placeholder={placeholder}
      options={options}
      required={required}
      className={className}
      disableCreatable={disableCreate}
      noOptionsText={tInput("address_result_area")}
      menuListFooter={<AddressSearchProviderFooter />}
      enableDefaultOptions={false}
      newOption={
        setShowAllFields
          ? {
              label: tInput("address_add_manually"),
              onClick: () => handleSwitchToAllFields(),
            }
          : undefined
      }
      customOnSelect={async (value) => {
        if (value) {
          if (Array.isArray(value)) {
            await handleSelect(
              value[0].value,
              prefix,
              name === "fakeStreet",
              setShowAllFields,
            );
          } else {
            await handleSelect(
              value.value,
              prefix,
              name === "fakeStreet",
              setShowAllFields,
            );
          }
        }
      }}
    />
  );
};

export default AddressAutocompleteInput;
